import React from 'react'
import cx from 'classnames'
import { l } from '@manychat/manyui'

import { FieldType } from 'common/fields/entities/enums'
import cm from 'common/filter/components/Filters/Filters.module.css'
import { FieldTypesOperators, UNARY_OPERATORS } from 'common/filter/models/AudienceFilter/constants'
import { getDefaultConditionData } from 'common/filter/models/AudienceFilter/helpers'
import { PopoverList } from 'components/MuiPopover'

import ConditionValue from '../ConditionValue'

export default class ConditionEditor extends React.Component {
  handleOperatorChange = (e) => {
    const { condition, fieldDesc } = this.props

    const operator = e.currentTarget.dataset.op
    const closePopover = UNARY_OPERATORS.includes(operator)

    if (fieldDesc.type === FieldType.SYSTEM_CURRENT_DATETIME) {
      this.props.onChange(
        {
          operator,
          ...getDefaultConditionData(condition.field, fieldDesc.type, operator),
        },
        closePopover,
      )
    } else {
      this.props.onChange({ operator }, closePopover)
    }
  }

  handleValueChange = (filter, closePopover) => {
    this.props.onChange(filter, closePopover)
  }

  handleValueKeyDown = (e) => {
    const { condition = {}, onRequestClose } = this.props
    if (e.keyCode === 13 && condition.value != null && condition.value !== '') {
      onRequestClose()
    }
  }

  render() {
    const { condition = {}, operatorDesc, fieldDesc, style, isBuilder, botTimezone } = this.props
    let operators = FieldTypesOperators[fieldDesc.type]

    if (fieldDesc.id === 'gender') {
      operators = operators.slice()
      operators.splice(1, 1)
    }

    return (
      <div className={cm.conditionEditor} style={style}>
        <PopoverList>
          {operators.map((op) => {
            const changedLabel = op.translatedChangedLabel
              ? l.getString(op.translatedChangedLabel)
              : op.changedLabel
            const label = op.translatedLabel ? l.getString(op.translatedLabel) : op.label
            return (
              <a key={op.value} onClick={this.handleOperatorChange} data-op={op.value}>
                <span
                  className={cx(cm.popoverEl, {
                    [cm.popoverActiveEL]: operatorDesc.value === op.value,
                  })}
                >
                  {this.props.useChangedLabelForOperators ? changedLabel : label}
                </span>
              </a>
            )
          })}
        </PopoverList>
        <div
          className={cm.conditionValue}
          onKeyDown={this.handleValueKeyDown}
          data-test-id="field-condition-editor"
          data-onboarding-id="field-condition-editor"
        >
          <ConditionValue
            fieldDesc={fieldDesc}
            operatorDesc={operatorDesc}
            condition={condition}
            onChange={this.handleValueChange}
            onRequestClose={this.props.onRequestClose}
            allowDateFormula={this.props.allowDateFormula}
            isBuilder={isBuilder}
            botTimezone={botTimezone}
          />
        </div>
      </div>
    )
  }
}
